import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { DrawerType } from "../models";
import { notificationsCountAtom } from "../recoil";
import { useDrawers } from "./use-drawers";

export const useNotificationBell = () => {
  const bellNotificationsCount = useRecoilValue(notificationsCountAtom);
  const { openDrawer, drawers } = useDrawers();
  const isNotificationDrawerOpened = useMemo(() => {
    return Boolean(
      drawers.find(
        ({ drawerProps: { type } }) => type === DrawerType.Notifications,
      ),
    );
  }, [drawers]);
  const isBadge =
    bellNotificationsCount === undefined ? false : bellNotificationsCount > 0;
  const badgeContent = bellNotificationsCount;

  const onMenuItemClick = (): void => {
    if (isNotificationDrawerOpened) {
      return;
    }

    openDrawer({
      drawerProps: { type: DrawerType.Notifications },
    });
  };

  return { onMenuItemClick, isBadge, badgeContent, isNotificationDrawerOpened };
};
